export default __webpack_public_path__ + "static/media/woman1.d7537c44.png";